import React, { useState } from "react";
import {
  Paper,
  TextField,
  Typography,
  Button,
  Stack,
  IconButton,
  Box,
  MenuItem,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { toastAlert } from "../../../utils/AlertContext";

export const Indicadores = ({
  value = {
    Financieros: [],
    Economia: [],
    Criptomonedas: [],
  },
  onChange,
}) => {
  const [text, setText] = useState("");
  const data = value;

  const handleProcess = () => {
    if (!text.trim()) {
      toastAlert("No hay información para procesar", "warning");
      return;
    }

    const lines = text.split("\n").filter(Boolean);

    const newData = {
      Financieros: [...data.Financieros],
      Economia: [...data.Economia],
      Criptomonedas: [...data.Criptomonedas],
    };

    const errors = [];
    let successCount = 0;

    lines.forEach((line, index) => {
      const separator = line.includes("|") ? "|" : "/";
      const parts = line.split(separator).map((x) => x.trim());
      const category = parts[0];

      if (!["Financieros", "Economia", "Criptomonedas"].includes(category)) {
        errors.push(`Línea ${index + 1}: categoría inválida (Financieros, Economia, Criptomonedas)`);
        return;
      }

      if (
        (category === "Financieros" || category === "Criptomonedas") &&
        parts.length !== 6
      ) {
        errors.push(`Línea ${index + 1}: formato incorrecto (6 valores requeridos). Ejemplo: Financieros|DÓLAR SPOT|17.38|17.39|0.02|true`);
        return;
      }

      if (category === "Economia" && parts.length !== 7) {
        errors.push(`Línea ${index + 1}: formato incorrecto (7 valores requeridos). Ejemplo: Economia|BRASIL|Bovespa|190.745,02|189.578,80|0.61|false`);
        return;
      }

      try {
        if (category === "Economia") {
          const [, p, i, a, c, v, up] = parts;

          newData.Economia.push({
            id: Date.now() + Math.random(),
            p,
            i,
            a,
            c,
            v,
            up: up === "true",
          });
        } else {
          const [, p, a, c, v, up] = parts;

          newData[category].push({
            id: Date.now() + Math.random(),
            p,
            a,
            c,
            v,
            up: up === "true",
          });
        }

        successCount++;
      } catch {
        errors.push(`Línea ${index + 1}: error al procesar`);
      }
    });

    if (errors.length > 0) {
      toastAlert(errors.slice(0, 3).join(" | "), "error", 6000);
    }

    if (successCount > 0) {
      onChange(newData);
      setText("");
      toastAlert(`${successCount} registro(s) agregados correctamente`, "success");
    }
  };

  const handleUpdateField = (section, id, field, value) => {
    const newData = {
      ...data,
      [section]: data[section].map((item) =>
        item.id === id
          ? { ...item, [field]: field === "up" ? value === "true" : value }
          : item
      ),
    };

    onChange(newData);
  };

  const handleDeleteRow = (
    section,
    id
  ) => {
    const newData = {
      ...data,
      [section]: data[section].filter(
        (item) => item.id !== id
      ),
    };

    onChange(newData);
  };

  return (
    <Stack spacing={3}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" mb={2}>
          Captura rápida
        </Typography>

        <TextField
          multiline
          rows={8}
          fullWidth
          value={text}
          onChange={(e) =>
            setText(e.target.value)
          }
          placeholder={`Financieros|DÓLAR SPOT|17.38|17.39|0.02|true
Economia|BRASIL|Bovespa|190.745,02|189.578,80|0.61|false
Criptomonedas|BITCOIN|109,643.34|108,883.34|0.70|true`}
        />

        <Button
          variant="contained"
          sx={{ mt: 2 }}
          onClick={handleProcess}
        >
          Procesar
        </Button>
      </Paper>

      {Object.keys(data).map((section) => (
        <Paper key={section} sx={{ p: 2 }}>
          <Typography variant="h6" mb={1}>
            {section}
          </Typography>

          {data[section].length === 0 ? (
            <Typography
              variant="body2"
              color="text.secondary"
            >
              Sin datos
            </Typography>
          ) : (
            data[section].map(
              (item) => (
                <Box
                  key={item.id}
                  sx={{
                    display: "flex",
                    gap: 1,
                    alignItems: "center",
                    py: 1,
                    borderBottom: "1px solid #eee",
                  }}
                >
                  <TextField
                    size="small"
                    label="P"
                    value={item.p}
                    onChange={(e) =>
                      handleUpdateField(section, item.id, "p", e.target.value)
                    }
                  />

                  {section === "Economia" && (
                    <TextField
                      size="small"
                      label="I"
                      value={item.i}
                      onChange={(e) =>
                        handleUpdateField(section, item.id, "i", e.target.value)
                      }
                    />
                  )}

                  <TextField
                    size="small"
                    label="A"
                    value={item.a}
                    onChange={(e) =>
                      handleUpdateField(section, item.id, "a", e.target.value)
                    }
                  />

                  <TextField
                    size="small"
                    label="C"
                    value={item.c}
                    onChange={(e) =>
                      handleUpdateField(section, item.id, "c", e.target.value)
                    }
                  />

                  <TextField
                    size="small"
                    label="V"
                    value={item.v}
                    onChange={(e) =>
                      handleUpdateField(section, item.id, "v", e.target.value)
                    }
                  />

                  <TextField
                    select
                    size="small"
                    label="↑↓"
                    value={item.up === true ? "true" : "false"}
                    onChange={(e) =>
                      handleUpdateField(section, item.id, "up", e.target.value)
                    }
                    sx={{ minWidth: 80 }}
                  >
                    <MenuItem value="true">▲</MenuItem>
                    <MenuItem value="false">▼</MenuItem>
                  </TextField>

                  <IconButton
                    color="error"
                    size="small"
                    onClick={() => handleDeleteRow(section, item.id)}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              )
            )
          )}
        </Paper>
        ))}
    </Stack>
  );
};
